
import { defineComponent } from 'vue'
// import PatientDocuments from './PatientDocuments.vue'
import PatientDetails from './PatientDetails.vue'
import PatientKins from './PatientKins.vue'
import PatientOthderDetails from './PatientOtherDetails.vue'
import PatientEmployment from './PatientEmployment.vue'
import PatientInsurance from './PatientInsurance.vue'

export default defineComponent({
  name: 'PatientDemographics',
  props: ['patient'],
  components: { 
    // PatientDocuments,
    PatientDetails,
    PatientKins,
    PatientOthderDetails,
    PatientEmployment,
    PatientInsurance
  },
  data () {
    return {
      tab: null
    }
  }
})
